<template>
  <div class="public-navbar">
    <v-toolbar v-resize="onResize" dark fixed app clipped-left
      :color="dark ? 'white' : 'black'"
      :class="
        user != null && showPanelInv != false
          ? { [`pt-${isMobile ? 0 : 0}`]: true }
          : { [`pt-${isMobile ? 0 : 0}`]: true }
      "
    >
      <!-- Menu Movil -->
      <v-toolbar-side-icon flat color="primary" v-if="isMobile" alt="Mostrar menu" aria-label="Menu" @click="showMenu = true"></v-toolbar-side-icon>
      <router-link to="/" style="margin: auto;padding-right: 36px;">
        <img class="rclogo" alt="Iris logo" src="/images/iris/logo_IRIS.png"/>
      </router-link>
      <!-- Menu Desk -->
      <v-toolbar-items v-if="!isMobile" style="width:100%"> 
        <v-spacer />
        <v-btn v-if="user != null && user.user_tipo_id == 1" to="/admin/asociar" flat>Controlar cuenta</v-btn>
        <v-btn v-if="user == null" 
               class=" rc-button_prim rc-btn_xs" 
               to="/registrar"
        >
          Registrarse
        </v-btn>
        <v-btn v-if="user == null" 
               class="ml-2 rc-button_scol rc-btn_xs"
               to="/login"
        >
          Ingresar
        </v-btn>

          <v-menu offset-y v-if="user != null">
          <template v-slot:activator="{ on }">
            <v-btn
              class="ml-2"
              style="
                text-transform: capitalize;
                height: auto;
                padding: 5px 17px;
                font-size: 1rem !important;
              "
              outline
              round
              color="#19B2A3"
              dark
              v-if="user != null"
              v-on="on"
              >{{ user.nombre }} {{ user.app_pat }}
              <v-icon>arrow_drop_down</v-icon></v-btn
            >
          </template>
          <v-list>
            <v-list-tile
              @click="panelFacture()" >
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat
                >Panel Solicitante</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-title class="ml-0 nav-1000 hidden-sm-and-down" flat
                >Cerrar sesión</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    
    <!-- Menu Movil RC HOME --> 
    <v-navigation-drawer v-model="showMenu"  left app fixed temporary class="rc-menuDrawerSitios">
        <v-list class="transparent pa-2" >
            <v-list-tile class="v-list-item rc-list-itemNav rc-listItem-pad" v-if="user == null" to="/registrar">
                <div style="text-align: center; width: 100%; line-height: 1;">
                    <div class="rc-listItem-title">Crear cuenta</div>
                </div>
            </v-list-tile>
            <v-list-tile class="v-list-item rc-list-itemNav rc-listItem-pad" v-if="user == null" @click="login">
                <div style="text-align: center; width: 100%; line-height: 1;">
                    <div class="rc-listItem-title">Ingresar</div>
                </div>
            </v-list-tile>
            <!-- Menus movil, solicitante, inversionista -->
            <v-list-group class="rc-list-itemNav rc-listNameUser" v-if="user != null">
                <template v-slot:activator>
                    <div style="text-align: center; width: 100%; line-height: 1;">
                        <span class="rc-listItem-img material-icons" style="height:26px;width:26px">account_circle</span>
                        <div class="rc-listItem-title">{{ nombreCompleto }}</div>
                    </div>
                </template>
                <div>
                    <v-list-tile v-for="(redCapitalSolicitanteMenu, index) in redCapitalSolicitanteMenus" :key="`${redCapitalSolicitanteMenu.icon}-${index}`" class="v-list-item rc-list-item rc-listItem-pad" :active-class="activeClassMenu" :to="redCapitalSolicitanteMenu.to.path ? redCapitalSolicitanteMenu.to.path : {name: redCapitalSolicitanteMenu.to.name}">
                        <div style="text-align: center; width: 100%; line-height: 1;">
                            <span class="rc-listItem-img material-icons-outlined" style="height:26px;width:26px">{{ redCapitalSolicitanteMenu.icon }}</span>
                            <div class="rc-listItem-title">{{ redCapitalSolicitanteMenu.text }}</div>
                        </div>
                    </v-list-tile>
                </div>
                <v-list-tile class="v-list-item rc-listItem-pad rc-listCerrarSesion" :active-class="activeClassMenu" @click="logout">
                    <div style="text-align: center; width: 100%; line-height: 1;">
                        <v-icon class="rc-listItem-img">logout</v-icon>
                        <div class="rc-listItem-title">Cerrar sesión</div>
                    </div>
                </v-list-tile>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import {
  Menus,
  menu2,
  Profile,
  ProfileInvestment,
  MyBusiness,
  MyDocuments,
  redCapitalInversionistaMenus,
  redCapitalSolicitanteMenus
} from "@/models/DashboardLinks";
import { EventBus } from "@/main";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";

@Component({
  computed: {
    ...mapState(["user", "menu", "showPanelInv", "businesSelected"]),
    canShowLinks() {
      return (
        this.$route.path.startsWith("/panel/") ||
        this.$route.path.startsWith("/panel-facto/")
      );
    },
    projectsVisibility() {
      return (
        this.$store.state.user != null ||
        RedCapitalConfig(SelectedCountry).Project.PublicVisibility
      );
    },
    activeClass() {
      return "primary white--text";
    },
    accountType() {
      return this.$store.state.user.user_tipo_id == 2
        ? "investor"
        : "applicant";
    },
    urlimag() {
      return this.$store.state.menu == 2
        ? "/images/sitio-inversionista.png"
        : "/images/sitio-solicitante.png";
    },
    valroutesfacto(){
      return (
      this.$route.path.startsWith("/panel-facto/")
      )
    },
    userAnglo(){
      return (
        this.$store.state.user != null && this.$store.state.user.via_id == 2 ? true : false
      )
    },
    activeClassMenu() {
      return "rc-menuPanelActive";
    },
    nombreUser(){
      if(this.$store.state.user != null){
        this.$data.nombreCompleto = this.capitalize(this.$store.state.user.nombre)+' '+this.capitalize(this.$store.state.user.app_pat);
        return this.$data.nombreCompleto;
      }
    }
  },
  data() {
    return {
      SelectedCountry,
      RedCapital,
      nombreCompleto: null,
      Menus,
      menu2,
      Profile,
      ProfileInvestment,
      MyBusiness,
      MyDocuments,
      redCapitalInversionistaMenus,
      redCapitalSolicitanteMenus,
      dark: true,
      canShowUserMenu: false,
      showMenu: false,
      isMobile: true,
      uglyLinks: [
        {
          to: "/quienes-somos",
          text: "Sobre nosotros",
        },
        {
          to: "/prensa",
          text: "En prensa",
        },
        {
          to: "/contacto",
          text: "Contacto",
        },
        {
          to: "/preguntas-frecuentes",
          text: "Preguntas frecuentes",
        },
        {
          to: "/garantia-riesgos",
          text: "Respaldos y riesgos",
        },
      ],
    };
  },
  methods: {
    gohablemos(){
                EventBus.$emit("goHablemos");
        },
    goToProducts(){
      EventBus.$emit("goProducts");
    },
    panelInversionist() {
      this.$store.commit("setMenu", 2);
      this.$router.push("/panel/estadisticas");
     
    },
    panelFacture() {
      this.$store.commit("setMenu", 3);
       this.$router.push("/panel-facto/estadisticas");
    },
    onResize() {
      if (window.innerWidth <= 1270) { /* Old 1080 */ /* 960 Old */
        this.$data.isMobile = true;
      } else {
        this.$data.isMobile = false;
        this.$data.showMenu = false;
      }
    },
    login() {
      this.$data.showMenu = false;
      this.$data.canShowUserMenu = false;
      EventBus.$emit("open-login-dialog");
    },
    logout() {
      EventBus.$emit("logout");
    },
    goblog(){
      window.open("https://blog.redcapital.cl/", '_blank');
    },
    golog(){
      window.open("https://prontopago.redcapital.cl/login", '_blank');
    },
    capitalize(texto){ // #Pendiente dejar esta funcion global para llamar donde sea.
      const lower = texto.toLowerCase();
      return texto.charAt(0).toUpperCase()+lower.slice(1); 
    }
  },
  beforeMount() {
    if(this.$store.state.user != null){
      this.$data.nombreCompleto = this.capitalize(this.$store.state.user.nombre)+' '+this.capitalize(this.$store.state.user.app_pat);
    }
  },
  watch: {
    nombreUser(newVal, oldVal){
      if(newVal != undefined || newVal != null ){
        this.$data.nombreCompleto = newVal
      }
    }
  }
})
export default class NavBar extends Vue {}
</script>

<style lang="scss" scoped>
.font-OneRem{
  font-size: 1rem !important;
  font-weight: 500 !important;
}
.navbar {
  z-index: 3;
}
.rclogo {
  @media (max-width: 960px) {
    height: 40px;
  }
  @media (min-width: 960px) {
    height: 50px;
  }
}
.invlogo {
  @media (max-width: 960px) {
    height: 20px;
  }
  @media (min-width: 960px) {
    height: 25px;
  }
}
.dis-none {
  @media (max-width: 600px) {
    display: none;
  }
}

.v-menu__content {
  position: fixed !important;
  border-radius: 1rem !important;
}
.active {
  box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.btnsitio {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
  border-radius: 15px 15px 0px 0px;
}
.active2 {
  //box-shadow: 0px -2px 5px 0px rgb(195 87 14);
  //box-shadow: 4px 0 0px -2px #888;
  color: white;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.btnsitio2 {
  background-color: #ecded4 !important;
  color: #c3570f;
  //border-radius: 0.325rem 0.325rem 0px 0px;
}
.positionabs{
      position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -36px;
    text-align: right;
    right: 0;
}

// MENU
.rc-listItem-title{
    font-weight: 600;
}
// Breakpoints 
@each $breakpoint in $breakpoints_screen_text{
    @include breakpoint_media_queries($breakpoint){
        @if $breakpoint == "x-large"{
            
        }@else if $breakpoint == "large"{
            
        }@else if $breakpoint == "medium-to-large"{
            .rc-menuDrawerSitios{
                margin-top: 0 !important;
                z-index: 5;
                width: 300px !important;
            }
            .rc-listItem-img{
                float: left;
            }
            .rc-listItem-title{
                float: left;
                line-height: 2;
                margin-left: 10px;
            }
        }@else if $breakpoint == "small-to-medium"{
            .rc-menuDrawerSitios{
                margin-top: 0 !important;
                z-index: 5;
                width: 300px !important;
            }
            .rc-listItem-img{
                float: left;
            }
            .rc-listItem-title{
                float: left;
                line-height: 2;
                margin-left: 10px;
            }
        }@else if $breakpoint == "small"{
            .rc-menuDrawerSitios{
                margin-top: 0 !important;
                z-index: 5;
                width: 300px !important;
            }
            .rc-listItem-img{
                float: left;
            }
            .rc-listItem-title{
                float: left;
                line-height: 2;
                margin-left: 10px;
            }
        }
    }
}

/*.rc-listCerrarSesion{
    a{
        div{
            i{
                color: $rc-prim-n1 !important;
            }
            div
            {
                color: $rc-prim-n1 !important;
                font-weight: 600;
            }
        }
    }
}*/

</style>
